import { Box } from "@mui/material";
import { setImpersonationDetails } from "components/app/App.slice";
import ThemeContext from "components/app/Context";
import Button from "components/common/Button";
import Typography from "components/common/Typography";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { getUserName } from "utils/CommonFunctions";
import { reset } from "../AboveProperty/AboveProperty.slice";
import "./ImpersonateUser.scss";

function ImpersonateBanner() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { isMobileScreen } = useContext(ThemeContext);
  const accessRoles = useAppSelector((state) => state.app.loggedInUserDetails.accessRoles);
  const navigateToURL = useAppSelector((state: any) => state.app.impersonationDetails.navigateToURL);

  const onClickHandler = () => {
    dispatch(reset());
    navigate(navigateToURL);
    dispatch(
      setImpersonationDetails({
        isImpersonated: false,
        userDetails: {}
      })
    );
  };

  return (
    <Box className="impersonateUser-banner">
      <Box className="impersonateUser-banner-container">
        <Typography
          variant={"body2"}
          component="span"
          showBold
          changeVariant={false}
          color={tokens.Text.General.PrimaryBody}
        >
          Attention!
        </Typography>
        <Typography
          variant={"body2"}
          component="span"
          sx={{ marginLeft: "4px", marginRight: "12px" }}
          changeVariant={false}
          color={tokens.Text.General.PrimaryBody}
        >
          {accessRoles.update
            ? `You are impersonating “${getUserName()}”, ${
                !isMobileScreen &&
                "Any changes you make will alter their BOOST plans and actions without the ability to undo your changes."
              } All changes will also be recorded under your corporate login.`
            : `You are viewing BOOST as if you were - “${getUserName()}”. You have View Only Access.`}
        </Typography>
      </Box>
      <Button size="Small" label="Stop Impersonating" onClick={onClickHandler}></Button>
    </Box>
  );
}

export default ImpersonateBanner;
